import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";

const Slideshow = ({ images, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length > 1) {
      const slideInterval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, interval);

      return () => clearInterval(slideInterval);
    }
  }, [images, interval]);

  return (
    <div className="slider viewport-height">
      {images.map((image, index) => (
        <div
          key={index}
          className={`slider-item viewport-height ${index === currentIndex ? 'active' : ''}`}
          style={{ transition: 'opacity 1s', opacity: index === currentIndex ? 1 : 0 }}
        >
          <Image
            className="d-block w-100 object-cover object-center img-res"
            src={image}
            alt=""
            fluid
          />
        </div>
      ))}
    </div>
  );
};

export default Slideshow;
